export const modalClose = {
  svg: {
    fill: '#141424'
  }
}
